module.exports = __webpack_public_path__ + "img/20190612161939197.f6f5f635.png";